export default __webpack_public_path__ + "static/media/clock.1102f29b.svg";